<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" title="Gross Quiz!"><div class="titlepage"><div><div><h1 class="title"><a id="id1528186">Gross Quiz!</a></h1></div></div></div><a id="id1528186">
<p>Before you read any further, you might want to take this important quiz to learn how your
        views compare to the rest of society.</p>
</a><div class="orderedlist"><a id="id1528186"></a><ol class="orderedlist"><a id="id1528186"><li class="listitem">
<p><span class="bold"><strong>What’s the proper age to stop farting in
                public?</strong></span></p>
<p>a. 9</p>
<p>b. 19</p>
<p>c. I will be farting at my own funeral.</p>
</li><li class="listitem">
<p>
<span class="bold"><strong>You go to someone’s house for dinner and find that they have
                    made baby rabbit stew and lamprey surprise. (“Surprise! We made lampreys!”) You...</strong></span>
</p>
<p>a. Flee the house screaming.</p>
<p>b. Eat a little bit of the food while smiling politely.</p>
<p>c. Ask, “Could I have more baby rabbits, please?”<span class="inlinemediaobject" title="This is an image of a rabbit."><img alt="Gross Quiz!" src="images/092.png"/></span></p>
</li><li class="listitem">
<p>
<span class="bold"><strong>Which of the following best describes your maturity
                    level?</strong></span>
</p>
<p>a. You’ve always gotten along better with adults than kids.</p>
<p>b. You’re as mature as most people your age.</p>
<p>c. <span class="emphasis"><em>Hee hee!</em></span> “Mature” rhymes with “manure”!</p>
</li><li class="listitem">
<p>
<span class="bold"><strong>Eep! Somebody cut a bad one. You . . . </strong></span>
</p>
<p>a. Organize a protest march.</p>
<p>b. Breathe through your mouth.</p>
<p>c. Compliment the offender.</p>
</li></a><li class="listitem"><a id="id1528186">
</a><p><a id="id1528186">
<span class="bold"><strong>Driving along, you see some roadkill, perhaps an unlucky
                    armadillo or </strong></span></a><strong><span class="link" href="#/ch17#luwak" title="Link target outside of Sample">luwak</span>. You . . .</strong>
</p>
<p>a. Turn up the radio and accelerate.</p>
<p>b. Shake your head sadly at the fate of all living things.</p>
<p>c. Pull over and start searching your car for a spork.</p>
</li><li class="listitem">
<p>
<span class="bold"><strong>The phone rings. You are on the toilet. Do you answer
                    it?</strong></span>
</p>
<p>a. No!</p>
<p>b. Only if you are expecting a call.</p>
<p>c. Yes, and you supply the caller with a play-by-play account of what’s
                happening.</p>
</li><li class="listitem">
<p>
<span class="bold"><strong>You overhear a customer at a clothing store ask for some pants
                    with “maximum absorption.”</strong></span>
</p>
<p>a. You quickly distract yourself to avoid thinking about the situation.</p>
<p>b. You wonder: Which absorbs more fluid, cotton or wool?</p>
<p>c. You introduce yourself to the customer and show off how much fluid your
                trousers have already retained.</p>
</li><li class="listitem">
<p>
<span class="bold"><strong>If the alternative were starving to death, you would decide to
                    eat . . . </strong></span>
</p>
<p>a. <span class="link" href="#/ch17#haggis" title="Link target outside of Sample">Haggis</span>.</p>
<p>b. Your worst enemy’s poop.</p>
<p>c. A person.</p>
</li><li class="listitem">
<p>
<span class="bold"><strong>A friend of yours has something hanging from her nose,
                    probably a booger. She doesn’t realize it. You . . . </strong></span>
</p>
<p>a. Concentrate on looking at her forehead and mentally go to your “happy
                place.”</p>
<p>b. Make eye contact and then meaningfully point to your nose and make a swipe at
                it.</p>
<p>c. Lean in and say, “You have lovely mucus.”</p>
</li><li class="listitem">
<p>
<span class="bold"><strong>If your brother says the word “sputum,” you wonder . . .
                    </strong></span>
</p>
<p>a. Where your passport is, and how quickly you can book a flight to Italy.</p>
<p>b. How he got such a big vocabulary.</p>
<p>c. Whether he actually means <span class="link" href="#/ch16#mucus" title="Link target outside of Sample">mucus, snot, or phlegm</span>.</p>
</li></ol></div>
<p>For each question you answered with the letter “a,” give yourself one point. For each
        question you answered with the letter “b,” give yourself two points. For each question you
        answered with the letter “c,” give yourself three points.</p>
<p>
<span class="bold"><strong>If you scored from 10 to 14, you may be one of the
            following:</strong></span>
</p>
<p><span class="bold"><strong>The Accountant:</strong></span> “Dude, that’s the third time you’ve
        farted today.” Although the accountant does not tolerate gross stuff, he does a really good
        job of keeping track of it!</p>
<p><span class="bold"><strong>The Prissy Over-Reactor:</strong></span> “I’ve never smelled anything so
        horrible in my <span class="bold"><strong>LIFE</strong></span>!” Does this sound familiar? It should,
        because when it comes to making a big deal about gross stuff, this is you. </p>
<p><span class="bold"><strong>The Faker:</strong></span> Are you really that squeamish? (Or is it
        possible that, while you <span class="emphasis"><em>say</em></span> you can’t stand gross stuff, you secretly
            <span class="emphasis"><em>love it?</em></span>)</p>
<p>
<span class="bold"><strong>If you scored from 14 to 26, you may be:</strong></span>
</p>
<p><span class="bold"><strong>The Philosopher:</strong></span> You have a matter-of-fact way of looking
        at the world. Your relaxed attitude gives you good perspective, and so you are unlikely to
        get too worked up over gross stuff.</p>
<p>
<span class="bold"><strong>If you scored from 27 to 30, you may be:</strong></span>
</p>
<p><span class="bold"><strong>The Enthusiast:</strong></span> You’re so enthusiastic about gross stuff,
        you always do everything bigger, stinkier, and with more mucus than your friends do. You may
        sometimes be viewed as a little creepy (and even subhuman!) by “normal” people. This is
        horribly unfair, except in cases where you actually <span class="bold"><strong>ARE</strong></span>
        creepy and subhuman! </p>
<div class="mediaobject" title="This is an image of a cockroach."><img alt="Gross Quiz!" src="images/022.png"/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch03.vue?164cbbda